var enumerableProperties = {};
for (let key in '') enumerableProperties[key] = true;

/* istanbul ignore file */
if (!Number.prototype.rangeTo)
  Number.prototype.rangeTo = function (intTo) {
    var intFrom = parseInt(this);
    var step = intFrom <= intTo ? 1 : -1;
    var ret = [];
    do {
      ret.push(intFrom);
      if (intFrom == intTo)
        break;
      intFrom += step;
    } while (true); // eslint-disable-line
    return ret;
  }

if (!Number.prototype.round)
  Number.prototype.round = function (numOfDecimals) {
    var pow = Math.pow(10, numOfDecimals || 0);
    return Math.round((this + Number.EPSILON) * pow) / pow;
  }

var noEnumerableProperties = {};
for (let key in '') {
  if (!enumerableProperties[key]) noEnumerableProperties[key] = { enumerable: false };
}
Object.defineProperties(String.prototype, noEnumerableProperties);